import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface CoverCropCellDisplayProps {
  value: any
}

export const CoverCropCellDisplay = ({ value }: CoverCropCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/CoverCropEditor')
  const { t: cropT } = useTranslation('@cibo/ui/cropNames')

  if (value?.input?.crop) {
    return (
      <Stack flex={1} justifyContent="center">
        <Typography variant="body1">{cropT(value.input?.crop)}</Typography>
        {!!value.input?.plantedAt && !!value.input?.terminatedAt && (
          <Typography variant="body2" color="text.secondary">
            {t('dates', {
              plant: new Date(value.input?.plantedAt),
              harvest: new Date(value.input?.terminatedAt),
            })}
          </Typography>
        )}
      </Stack>
    )
  }

  return (
    <Stack flex={1} overflow="hidden">
      <Typography>{value?.result ? t('yes') : t('no')}</Typography>
    </Stack>
  )
}
